import React from 'react'
import "../hero.css";

function Hero() {
    return (
    <section className='hero'>
        <div className='hero-content'>
        <h1>Building Your <span class="highlight">Dream</span> Home.</h1>
        <p>Specializing in custom residential architecture and high-end construction with precision and passion.</p>
        <div className='hero-btns'>
            <a href='/portfolio#dlc_form'><button className='btn-primary'>Start Your Project</button></a>
            <a href='/portfolio'><button className='btn-secondary'>View Portfolio</button></a>
        </div>
        </div>

    </section>
    )
}

export default Hero;